import { Injectable } from "@angular/core";
import { checkCurrentID } from "@app/shared/resources/data-actions";
import { EquatorServiceMetadataService } from "@app/shared/services/equator-api/equator-services";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action, select, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { DataActions, ServiceMetadataActions } from "../actions";
import { ServiceMetadataResultPayload } from "../actions/service-metadata.actions";
import { ProjectSelectors } from "../selectors";

@Injectable()
export class ServiceMetadataEffects {
    constructor(
        private readonly actions$: Actions,
        private readonly serviceMetadataDbService: EquatorServiceMetadataService,
        private readonly store: Store
    ) {}

    getDeviceMetadata$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ServiceMetadataActions.ActionTypes.GetServiceMetadata),
            map((action: ServiceMetadataActions.GetServiceMetadata) => action.payload),
            switchMap(payload =>
                DataActions.toAction()(
                    this.serviceMetadataDbService.get(payload.uuid).pipe(
                        checkCurrentID(this.store.pipe(select(ProjectSelectors.getUuid)), payload.uuid),
                        map(
                            metadata =>
                                ({
                                    uuid: payload.uuid,
                                    result: metadata,
                                } as ServiceMetadataResultPayload)
                        )
                    ),
                    ServiceMetadataActions.GetServiceMetadataSuccess,
                    ServiceMetadataActions.GetServiceMetadataFailure
                )
            )
        )
    );
}
